import { computed } from '@vue/composition-api';
import MailTemplateEditor from '@/orm/models/Company/NotificationTemplate/MailTemplateEditor';

export default function useMailTemplateEditor() {
  const mailTemplate = computed(() => MailTemplateEditor.query().first());

  const fetchMailTemplate = async () => {
    await MailTemplateEditor.api().fetchMailTemplate();
  };

  const updateMailTemplate = async (payload) => {
    await MailTemplateEditor.api().updateMailTemplate(payload);
  };

  const applyRedactingMailTemplate = async () => {
    await MailTemplateEditor.api().applyRedactingMailTemplate();
  };

  const publishMailTemplate = async () => {
    await MailTemplateEditor.api().publishMailTemplate();
  };

  const unpublishMailTemplate = async () => {
    await MailTemplateEditor.api().unpublishMailTemplate();
  };

  return {
    mailTemplate,
    fetchMailTemplate,
    updateMailTemplate,
    applyRedactingMailTemplate,
    publishMailTemplate,
    unpublishMailTemplate,
    isPublished: computed(() => mailTemplate.value?.isPublished ?? false),
  };
}
